import createFocusTrap from 'focus-trap';
import focusWithin from '@plugins/focus-within';

export default class SiteHeader {

  constructor() {
    this.$element = $('#site-header');

    if (!this.$element) {
      return;
    }

    // Settings
    this.desktopHoverDelay = 300;

    // Initial state
    this.isMobileMenuOpen = false;

    // Get DOM objects
    this.$body = $('body');
    this.$mobile = this.$element.find('#site-header-mobile');
    this.$mobileToggle = this.$mobile.find('#site-header-mobile-toggle');
    this.$mobileMenu = this.$mobile.find('#site-header-mobile-menu');
    this.$desktopMainMenu = this.$element.find('#site-header-desktop-main-menu');

    // Initialize mobile menu focus trap
    this.mobileFocusTrap = createFocusTrap(this.$mobile[0], {
      escapeDeactivates: false
    });

    // Initialize resize watcher, to make sure we don't get stuck in
    // no-scrolling mode from: open mobile menu, then expand window past
    // breakpoint
    $(window).on('resize', () => {
      this.onWindowResize();
    });

    // Initialize mobile menu toggle
    this.$mobileToggle.attr('aria-controls', 'site-header-mobile-menu');
    this.$mobileToggle.attr('aria-expanded', 'false');
    this.$mobileToggle.on('click', () => {
      this.onMobileToggleClick();
    });
    this.$mobileToggle.removeAttr('disabled');

    // Initialize mobile menu submenu & back buttons
    this.$mobileMenu.on('click', 'button[data-target-screen]', (e) => {
      this.onSubmenuButtonClick(e);
    });

    // Toggle class on nav items on focus/blur of descendants
    focusWithin('.site-header', '-focus-within');
    focusWithin('.site-header-desktop-main-menu-item.-has-dropdown', '-dropdown-open');

    // Initialize desktop menu dropdown logic
    this.$desktopMainMenu.find('.site-header-desktop-main-menu-item.-has-dropdown')
      .on('mouseenter', (e) => {
        this.itemHoverTimer = setTimeout(this.desktopMainItemHover, this.desktopHoverDelay, e.currentTarget);
      })
      .on('mouseleave', (e) => {
        // If dropdown is pending to open due to previous mouseenter, cancel it.
        clearTimeout(this.itemHoverTimer);

        // Ensure the dropdown on the "left" item is closed - UNLESS focus is
        // within the item.
        if (!e.currentTarget.contains(document.activeElement)) {
          $(e.currentTarget).removeClass('-dropdown-open');
        }
      });
    this.$desktopMainMenu.addClass('-js-init');

    // Modal triggered by search button on desktop
    $('#site-header-desktop-search').addClass('mfp-hide').removeAttr('hidden');
    $('#site-header-desktop-search-btn').magnificPopup({
      type: 'inline',
      alignTop: true,
      closeMarkup: '<button title="%title%" type="button" class="mfp-close"><span class="sr-text">Close Pop-up</span></button>',
      closeOnBgClick: false,
      focus: '#site-header-desktop-search-input',
      mainClass: 'site-header-desktop-search-modal -mfp-full-screen-width',
      midClick: true
    });
  }

  closeMenu() {
    // Restore scrolling in main page flow
    this.$body.css('overflow', '');

    this.mobileFocusTrap.deactivate();
    this.$mobile.removeClass('-mobile-menu-open');
    this.$mobileMenu.attr('hidden', '');
    this.$mobileToggle.attr('aria-expanded', 'false');

    this.isMobileMenuOpen = false;
  }

  desktopMainItemHover(target) {
    $(target).addClass('-dropdown-open');
  }

  showMenu() {
    // Stop scrolling in main page flow
    this.$body.css('overflow', 'hidden');

    this.$mobileMenu.removeAttr('hidden');
    // Force re-render
    this.$mobileMenu.height();
    this.$mobile.addClass('-mobile-menu-open');
    this.$mobileToggle.attr('aria-expanded', 'true');
    this.mobileFocusTrap.activate();

    this.isMobileMenuOpen = true;
  }

  onMobileToggleClick() {
    if (this.isMobileMenuOpen) {
      this.closeMenu();
    } else {
      this.showMenu();
    }
  }

  onSubmenuButtonClick(event) {
    if (this.isSubmenuAnimating) {
      // Ignore additional input during animation
      return;
    }

    const $button = $(event.target),
          $currentSubmenu = $button.parents('[data-submenu-id]'),
          targetSubmenuId = $button.data('target-screen');

    const $targetSubMenu = this.$mobileMenu.find('[data-submenu-id="' + targetSubmenuId + '"]');
    if (!$targetSubMenu.length) {
      throw 'Could not find target screen with ID "' + targetSubmenuId + '"';
    }

    $targetSubMenu.removeAttr('hidden');
    $targetSubMenu.focus();
    $currentSubmenu.attr('hidden', '');
  }

  onWindowResize() {
    // If body scrolling is disabled and we have resized to reveal the desktop
    // menu, allow body scrolling again.
    if (this.isMobileMenuOpen && !this.$mobile.is(':visible')) {
      this.closeMenu();
    }
  }

}
